import { Layout } from 'antd';

export const AntLayout = Layout;
export const AntLayoutContent = Layout.Content;
